export const fmtNum = (n, maxFrac = 4) => {
  const v = Number(n);
  return Number.isFinite(v) ? v.toLocaleString("en-US", { maximumFractionDigits: maxFrac }) : (n ?? "");
};
